var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconOrder(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.4 19.5a.752.752 0 1 1 0-1.5h4.8a.752.752 0 1 1 0 1.5zM13.8 6.75a.8.8 0 0 1-1.6 0v-6a.8.8 0 0 1 1.6 0zm10.927.466a.735.735 0 0 1-.437.978.819.819 0 0 1-1.044-.41L20.7 1.946a.8.8 0 0 0-.735-.446H6.038a.8.8 0 0 0-.724.425l-2.56 5.859a.819.819 0 0 1-1.044.41.735.735 0 0 1-.437-.978l2.569-5.879A2.412 2.412 0 0 1 6.04 0h13.919a2.419 2.419 0 0 1 2.208 1.357zM3.4 22.5h19.2a.776.776 0 0 0 .8-.75V8.25a.776.776 0 0 0-.8-.75H3.4a.776.776 0 0 0-.8.75v13.5a.776.776 0 0 0 .8.75zm0 1.5A2.329 2.329 0 0 1 1 21.75V8.25A2.329 2.329 0 0 1 3.4 6h19.2A2.329 2.329 0 0 1 25 8.25v13.5A2.329 2.329 0 0 1 22.6 24z",
    transform: "translate(-1)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconOrder);
export default __webpack_public_path__ + "static/media/icon-order.a3bedb73.svg";
export { ForwardRef as ReactComponent };